import JournalContainer from './JournalContainer';
export default JournalContainer;
